// extracted by mini-css-extract-plugin
module.exports = {"pageSegmentContent":"CrossSegmentCard-PageSegmentContent-module--page-segment-content--3twsD"};